import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './_Loader.scss';

/**
 * A component for displaying loading animation
 *
 * If you want to scale this component please use the mixin `b360m-loader-size`  provided in `_LoaderMixins.scss`
 */
class Loader extends PureComponent {
  render() {
    const { className, ...rest } = this.props;
    return (
      <div {...rest} className={classNames('Loader', className)}>
        <div className="Loader__scaling-container">
          <div className="Loader__animation-container">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
      </div>
    );
  }
}

Loader.propTypes = {
  className: PropTypes.string
};

export default Loader;
